import logo from 'assets/images/logo/leadchain-logo.png';
const Logo = () => {
  return (
    <img src={logo} alt={logo} width="160" />
  );
};
export default Logo;